import { z } from 'zod';
import { RequestError } from './request_errors';

export class BusinessError extends RequestError {
  constructor(message: string, details?: Record<string, unknown>) {
    super(message, 400, details);
  }
}

export class NotFoundError extends RequestError {
  constructor(message: string, details?: Record<string, unknown>) {
    super(message, 404, details);
  }
}

export class ConflictError extends RequestError {
  constructor(message: string, details?: Record<string, unknown>) {
    super(message, 409, details);
  }
}

export class ValidationError extends RequestError {
  issues: z.core.$ZodIssue[];

  constructor(error: z.ZodError) {
    super(z.prettifyError(error), 400);
    this.issues = error.issues;
  }
}

/**
 * Thrown by the imperative invariant-check helpers in
 * `entities/board/invariants.ts` when a `Card` / `Task` object built
 * programmatically violates a spec invariant that Zod cannot express on
 * its own (e.g. "the closing actor is human", which depends on an
 * external lookup).
 *
 * Carries a stable `code` so callers can distinguish it from other
 * errors without `instanceof`, and a `field` discriminant identifying
 * which invariant failed.
 */
export type InvariantField = 'task.status' | 'card.id' | 'user.id';

export class InvariantViolationError extends Error {
  readonly code = 'INVARIANT_VIOLATION' as const;
  readonly field: InvariantField;

  constructor(field: InvariantField, message: string) {
    super(message);
    this.name = 'InvariantViolationError';
    this.field = field;
  }
}
